/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
export const getHumanReadableFileSize = (bytes: number, si = false, dp = 1) => {
  const thresh = si ? 1000 : 1024;
  let tempBytes = bytes;
  if (Math.abs(tempBytes) < thresh) {
    return `${tempBytes} B`;
  }

  const units = si
    ? ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let u = -1;
  const r = 10 ** dp;

  do {
    tempBytes /= thresh;
    u += 1;
  } while (
    Math.round(Math.abs(tempBytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return `${tempBytes.toFixed(dp)} ${units[u]}`;
};

export const getExtensionFromFileKey = (fileKey: string) => {
  if (fileKey && fileKey.length) {
    const reg = /(?:\.([^.]+))?$/;

    const fileExec = reg.exec(fileKey);
    const fileExtension =
      fileExec !== null && fileExec.at(0) ? fileExec.at(0) : '';
    return fileExtension ?? '';
  }

  return '';
};

export const getFileNameFromFileKey = (
  fileKey: string,
  options?: { withExtension: boolean },
) => {
  if (fileKey && fileKey.length) {
    const fileKeyStaged = fileKey.split('/');
    if (fileKeyStaged.length >= 2) {
      const fileName =
        options && options.withExtension
          ? (fileKeyStaged[fileKeyStaged.length - 1] ?? '')
          : (fileKeyStaged[fileKeyStaged.length - 1] ?? '').replace(
              /\.[^/.]+$/,
              '',
            );
      return fileName;
    }
  }

  return '';
};
